import { Box, Flex, IconButton, Stack, Text, Tooltip, useToast } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";
import { useState } from "react";

interface SecretFieldProps {
  workspaceKey: string;
  children?: React.ReactNode;
  onToggleVisible?: (isVisible: boolean) => void;
}

export const SecretField = (props: SecretFieldProps) => {
  const [isWorkspaceKeyVisible, setIsWorkspaceKeyVisible] = useState(false);
  const toast = useToast();
  const { workspaceKey, children, onToggleVisible } = props;

  // hide the middle of the workspace key
  const hiddenKey = workspaceKey ? workspaceKey.slice(0, 8) + "********" + workspaceKey.slice(-2) : "";
  const workspaceKeyToDisplay = isWorkspaceKeyVisible ? workspaceKey : hiddenKey;

  const copyKey = () => {
    navigator.clipboard.writeText(workspaceKey);
    toast({
      position: "top",
      title: "Workspace key copied to clipboard",
      status: "success",
      duration: 1000,
      size: "sm",
    });
  };

  return (
    <Flex direction="column" gap="0.5" width="100%">
      <Tooltip label="Use this key when calling deployments in this workspace">
        <Text textStyle="label/S/regular" color="foreground.secondary">
          Workspace Key
        </Text>
      </Tooltip>
      <Flex gap="1" flex="1" alignItems="center">
        <Tooltip label="Click to copy workspace key">
          <Box
            cursor="pointer"
            flex="1"
            border="2px solid"
            borderColor={"border.secondary"}
            paddingY="0.4rem"
            paddingX="2"
            height="2.1rem"
            borderRadius="8px"
            onClick={copyKey}
          >
            <Text noOfLines={1} textStyle="label/S/regular">
              {workspaceKeyToDisplay}
            </Text>
          </Box>
        </Tooltip>
        <Stack direction="row">
          <Tooltip label={isWorkspaceKeyVisible ? "Hide workspace key" : "Show workspace key"}>
            <IconButton
              size="sm"
              aria-label="Show workspace key"
              icon={isWorkspaceKeyVisible ? <Icon name="eye-slash" /> : <Icon name="eye" />}
              onClick={() => {
                setIsWorkspaceKeyVisible(!isWorkspaceKeyVisible);
                onToggleVisible?.(!isWorkspaceKeyVisible);
              }}
            />
          </Tooltip>
          {children}
        </Stack>
      </Flex>
    </Flex>
  );
};
